export function add(element, position = 'top') {
  setNewPadding(element, position, 'add');
}

export function remove(element, position = 'top') {
  setNewPadding(element, position, 'remove');
}

function setNewPadding(element, position = 'top', operation = 'add') {
  const panelLeft = document.querySelector('.panel-left');
  const views     = document.querySelector('.views');

  if (!panelLeft || !views)
    return;

  const elementHeight           = element.offsetHeight;
  const capitalizedPosition     = `${position.charAt(0).toUpperCase()}${position.substr(1)}`;
  const cssProperty             = `padding${capitalizedPosition}`;
  const panelLeftCurrentPadding = parseInt(panelLeft.style[cssProperty], 10) || 0;
  const viewsCurrentPadding     = parseInt(panelLeft.style[cssProperty], 10) || 0;

  if (operation === 'add') {
    panelLeft.style[cssProperty] = `${panelLeftCurrentPadding + elementHeight}px`;
    views.style[cssProperty]     = `${viewsCurrentPadding + elementHeight}px`;
  } else {
    const panelLeftNewPadding    = panelLeftCurrentPadding - elementHeight;
    const viewsNewPadding        = viewsCurrentPadding - elementHeight;
    panelLeft.style[cssProperty] = `${panelLeftNewPadding >= 0 ? panelLeftNewPadding : 0}px`;
    views.style[cssProperty]     = `${viewsNewPadding >= 0 ? viewsNewPadding : 0}px`;
  }
}
